module.exports = __webpack_public_path__ + "img/img4.a020c8a.png";